import { apiSlice } from "../../../app/service/Service";

export const VerifyMailSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
   
        verifyMail: builder.mutation({
            query(data) {
                const { email } = data;
                console.log("email",email);
                return {
                    url: `Account/VerifyEmail?email=${email}`,
                    method: "GET",
                }
            }
        }),
        
    })
})

export const { useVerifyMailMutation } = apiSlice;

